import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import Home from "./Pages/Home";
import Legal from "./Pages/Legal";
import NotFound from "./Pages/NotFound";
// import Appointment from "./Pages/Appointment";
import Services from "./Pages/Services";
import About from "./Pages/About";
import Doctors from "./Pages/Doctors";
import Gallery from "./Pages/Gallery";
import PageTransition from "./Components/PageTransition";
import ChatBot from "./Components/ChatBot";
import WhatsAppFloat from "./Components/WhatsAppFloat";

function App() {
  return (
    <div className="App">
    <Router>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<PageTransition><Home /></PageTransition>} />
            <Route path="/home" element={<PageTransition><Home /></PageTransition>} />
            <Route path="/legal" element={<PageTransition><Legal /></PageTransition>} />
            {/* <Route path="/appointment" element={<PageTransition><Appointment /></PageTransition>} /> */}
            <Route path="/services" element={<PageTransition><Services /></PageTransition>} />
            <Route path="/about" element={<PageTransition><About /></PageTransition>} />
            <Route path="/doctors" element={<PageTransition><Doctors /></PageTransition>} />
            <Route path="/gallery" element={<PageTransition><Gallery /></PageTransition>} />
            <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
          </Routes>
        </AnimatePresence>
        <ChatBot />
        <WhatsAppFloat />
      </Router>
    </div>
  );
}

export default App;
